import { useColumnVisibility } from './use-column-visibility';
import { useColumnPinning } from './use-column-pinning';
import { useColumnOrder } from './use-column-order';
import { useColumnSizing } from './use-column-sizing';
import { useNames } from './use-names';
import { useSorting } from './use-sorting';
import { useTableFilters } from './use-table-filters';
import { usePagination } from './use-pagination';

import type { TableIdentifyingData, TInitialSettings } from '../types';
import { useGetCurrentView } from '@src/shared/hooks/use-get-current-view';

export const useInitializeTableStates = (
  identifyingData?: TableIdentifyingData,
  initialSettings?: TInitialSettings
) => {
  const { tableKey = '', viewEntityId, viewEntityType } = identifyingData ?? {};
  const viewData = useGetCurrentView({
    viewEntityId,
    viewEntityType,
  });

  return {
    ...useColumnVisibility(
      viewData.currentView,
      initialSettings?.visibles
    ),
    ...useColumnPinning(viewData.currentView),
    ...useColumnOrder(viewData.currentView, initialSettings?.ordering),
    ...useColumnSizing(viewData.currentView),
    ...useNames(viewData.currentView),
    ...useSorting(viewData.currentView),
    ...useTableFilters(viewData.currentView),
    ...usePagination(tableKey),
    ...viewData,
  };
};
